import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog'; // Importación actualizada
import { ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';
import { EncuestaService } from 'src/app/services/encuesta.service';
import { EncuestasServiceService } from 'src/app/services/encuestas-service.service';

@Component({
    selector: 'app-nuevo-ciclo',
    templateUrl: './nuevo-ciclo.component.html',
    styleUrls: ['./nuevo-ciclo.component.scss'],
    standalone: false,
    providers: [
      //{ provide: MAT_DATE_FORMATS, useClass: MY_DATE_FORMATS }
      DatePipe,
      provideNativeDateAdapter(),
    ],
})
export class NuevoCicloComponent implements OnInit {
  aplicacion: any;
  encuestas = [];
  isLoading = false;
  id: number;
  grados = ["1ro", "2do", "3ro", "4to", "5to", "6to"];
  grupos = ["A", "B", "C", "D"];
  publicos = ["Alumnos", "Papás", "Docentes"];

  formulario = new FormGroup({
    ciclo: new FormControl("", [Validators.required]),
    publico: new FormControl("", [Validators.required]),
    grado: new FormControl("", [Validators.required]),
    grupo: new FormControl("", [Validators.required]),
    encuesta: new FormControl("", [Validators.required]),
    apertura: new FormControl("", [Validators.required]),
    cierre: new FormControl("", [Validators.required])
  });

  constructor(
    private _encuestaService: EncuestasServiceService,
    private dialog: MatDialog, // Cambiado aquí
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.id = params['id'];
    });
  }

  get form() {
    return this.formulario.controls;
  }

  ngOnInit(): void {
    this.loadEncuestas();

    if (this.id > 0) {
      this.isLoading = true;
      this.loadEncuestaById(this.id);
    }
  }

  loadEncuestas() {
    this._encuestaService.getEncuestas().subscribe(result => {
      if (result.code === 200) {
        this.encuestas = result.datos;
      } else {
        this.encuestas = [];
      }
    }, error => {
      console.error(error);
      this.encuestas = [];
    });
  }

  loadEncuestaById(id: number) {
    this._encuestaService.getEncuestaById(id).subscribe(result => {
      this.isLoading = false;
      if (result.code === 200) {
        this.aplicacion = result.datos;
        this.form.ciclo.setValue(this.aplicacion.ciclo);
        this.form.publico.setValue(this.aplicacion.publico);
        this.form.grado.setValue(this.aplicacion.grado);
        this.form.grupo.setValue(this.aplicacion.grupo);
        this.form.encuesta.setValue(this.aplicacion.id_encuesta_fk);
        this.form.apertura.setValue(this.aplicacion.fecha_inicio);
        this.form.cierre.setValue(this.aplicacion.fecha_fin);
      }
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  sendForm() {
    if (this.formulario.valid) {
      this.isLoading = true;
      if (this.id > 0) {
        this.updateEncuesta(this.id, this.formulario.getRawValue());
      } else {
        this.saveEncuesta(this.formulario.getRawValue());
      }
    }
  }

  updateEncuesta(id: number, data: any) {
    this._encuestaService.updateAplicacion(id, data).subscribe(result => {
      this.isLoading = false;
      if (result.code === 200) {
        this.dialog.open(MessageBoxComponent, {
          disableClose: true,
          data: { title: "Encuesta actualizada", text: "La encuesta ha sido actualizada con éxito.", icon: "done", href: "/medicion-resultados/ciclos-mannager" }
        });
      } else {
        this.showErrorDialog("Problemas al modificar la encuesta", "No fue posible modificar la encuesta, si piensa que esto es un error, contacte al administrador del sistema");
      }
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.showErrorDialog("Problemas al modificar la encuesta", "No fue posible modificar la encuesta, si piensa que esto es un error, contacte al administrador del sistema");
    });
  }

  saveEncuesta(data: any) {
    this._encuestaService.saveAplicacion(data).subscribe(result => {
      this.isLoading = false;
      if (result.code === 200) {
        this.dialog.open(MessageBoxComponent, {
          disableClose: true,
          data: { title: "Encuesta programada", text: "La encuesta ha sido programada con éxito.", icon: "done", href: "/medicion-resultados/ciclos-mannager" }
        });
      } else {
        this.showErrorDialog("Problemas al realizar el alta", "No fue posible crear la encuesta, si piensa que esto es un error, contacte al administrador del sistema");
      }
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.showErrorDialog("Problemas al realizar el alta", "No fue posible crear la encuesta, si piensa que esto es un error, contacte al administrador del sistema");
    });
  }

  showErrorDialog(title: string, text: string) {
    this.dialog.open(MessageBoxComponent, {
      disableClose: true,
      data: { title, text, icon: "error_outline", href: null }
    });
  }
}
